import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthProvider {
	public constructor(
		private jwt: JwtHelperService,
	) {

	}


	public getToken(): string {
		return localStorage.getItem('token');
	}


	public setToken(token: string) {
		localStorage.setItem('token', token);
	}


	public isAuthenticated(): boolean {
		const token = this.getToken();
		return !this.jwt.isTokenExpired(token);
	}
}



// WEBPACK FOOTER //
// ./src/app/core/providers/auth.ts